import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { ToastService, Msg } from '../toast-service.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-tailwind-toast-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tailwind-toast-message.component.html',
  styleUrl: './tailwind-toast-message.component.scss'
})
export class TailwindToastMessageComponent implements OnDestroy {
  public notify = inject(ToastService);
  public currentMessage: Msg | null = null;
  private destroy$ = new Subject<void>();

  constructor() {
    this.notify.msg.pipe(takeUntil(this.destroy$)).subscribe(message => {
      this.currentMessage = message;
    });
  }

  getStyleClasses(style: 'error' | 'info' | 'success' | undefined): string {
    switch (style) {
      case 'error':
        return 'bg-red-500 text-white';
      case 'info':
        return 'bg-blue-500 text-white';
      case 'success':
        return 'bg-green-500 text-white';
      default:
        return 'bg-gray-700 text-white';
    }
  }

  getIcon(style: 'error' | 'info' | 'success' | undefined): string {
    switch (style) {
      case 'error':
        return 'error';
      case 'info':
        return 'info';
      case 'success':
        return 'check_circle';
      default:
        return 'notifications';
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
